import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { DeploymentBuilderPage } from "@charphq/ui/components/layout/pages/DeploymentBuilderPage";

export const Route = createFileRoute("/deployments_/new")({
  component: DeploymentBuilderComponent,
  // `customerId` pre-selects the customer when the builder is started from a customer's page.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    customerId: typeof search.customerId === "string" ? search.customerId : undefined,
  }),
});

function DeploymentBuilderComponent() {
  const { customerId } = Route.useSearch();
  return <DeploymentBuilderPage initialCustomerId={customerId} />;
}
